<template>
  <section class="flex flex-col items-center my-200">
    <h2 class="headline-h4-headline text-center mb-100">
      {{ $t('scratchcard.quantitypicker.title') }}
    </h2>
    <div class="quantity-controls flex justify-center items-center">
      <ScratchcardQuantityButton
        :aria-label="$t('scratchcard.quantitypicker.action.increase')"
        class="mr-050"
        data-testid="scratchcard-quantity-picker-decrease-button"
        :disabled="!game || selectedQuantity! <= minQuantity!"
        icon="minus"
        @click="removeCard"
      />
      <span
        class="quantity headline-h3-headline text-center"
        data-testid="scratchcard-quantity-picker-scratchcard-quantity"
      >
        {{ selectedQuantity }}
      </span>
      <ScratchcardQuantityButton
        :aria-label="$t('scratchcard.quantitypicker.action.increase')"
        class="ml-050"
        data-testid="scratchcard-quantity-picker-increase-button"
        :disabled="!game || selectedQuantity! >= maxQuantity(availableCards)"
        icon="plus"
        @click="addCard"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useScratchcardStore } from '../stores/scratchcard'

const { availableCards, game } = useScratchcardGame()

const store = useScratchcardStore()
const { selectedQuantity } = storeToRefs(store)
const { maxQuantity, minQuantity, setSelectedQuantity } = store

const addCard = () => {
  if (!game.value) return

  setSelectedQuantity(
    Math.max(Math.min(selectedQuantity.value + 1, maxQuantity(availableCards.value))),
  )
}

const removeCard = () => {
  if (!game.value) return

  setSelectedQuantity(Math.min(Math.max(selectedQuantity.value - 1, minQuantity)))
}
</script>

<style lang="scss" scoped>
.quantity {
  width: 2.875rem;
}
</style>
